<div data-testing-id="checkout-review-page">
  <ish-checkout-review
    [basket]="basket$ | async"
    [error]="error$ | async"
    [submitting]="orderLoading$ | async"
    (createOrder)="onCreateOrder()"
  />

  <ish-loading *ngIf="loading$ | async" />
</div>
